import { render, staticRenderFns } from "./callus.vue?vue&type=template&id=d56d116c"
import script from "./callus.vue?vue&type=script&lang=js"
export * from "./callus.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports